import filled_star from 'src/assets/filled-star.png';
import empty_star from 'src/assets/empty-star.png';
import replay_icon from 'src/assets/replay-icon.png';
import filled_bookmark_icon from 'src/assets/filled_bookmark_icon.png';
import bookmark_icon from 'src/assets/bookmark-icon.png';

import React, { useEffect, useState } from 'react'
import closeDrawerIcon from 'src/assets/close_drawer.png'
import {
  CompletionFeedbackBox,
  CompletionFeedbackContainer,
  CompletionFeedbackHeader,
  CompletionFeedbackSubTitle,
  CompletionFeedbackTitle,
  CloseIcon,
  StarsContainer,
  ActionsContainer,
  CompletionFeedbackActions,
  ActionTitle,
  ActionSubmitButton,
  FilledStar,
  EmptyStar,
  ActionImage,
} from './CompletionFeedbackStyle'
import Rating from '@mui/material/Rating'
import { makeCourseFavorite } from 'src/consumer/services/featureServices'

export const CompletionFeedback = (props) => {
  const { onSessionCompleteSumbit, handleOnCompleteReplay, userFavoriteData, courseId } = props
  const [value, setValue] = useState(0)

  const [isCourseFavorite, setIsCourseFavorite] = useState(
    Boolean(userFavoriteData?.course?.[courseId]),
  )

  const handleFavoriteClick = () => {
    if (isCourseFavorite) {
      setIsCourseFavorite(false)
      makeCourseFavorite(courseId, false)
    } else {
      setIsCourseFavorite(true)
      makeCourseFavorite(courseId, true)
    }
  }

  return (
    <CompletionFeedbackContainer>
      <CompletionFeedbackBox>
        <CompletionFeedbackHeader>
          <CompletionFeedbackTitle>How was That?</CompletionFeedbackTitle>
          <CompletionFeedbackSubTitle>
            Please tell us so we can improve the experience for you
          </CompletionFeedbackSubTitle>
        </CompletionFeedbackHeader>

        <CloseIcon onClick={() => onSessionCompleteSumbit(value)} src={closeDrawerIcon} />

        <StarsContainer>
          <Rating
            name="no-value"
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue)
            }}
            size="large"
            sx={{ fontSize: '63px', border: 'white' }}
            icon={<FilledStar src={filled_star} fontSize="inherit" />}
            emptyIcon={<EmptyStar src={empty_star} fontSize="inherit" />}
          />
        </StarsContainer>

        <ActionsContainer>
          <CompletionFeedbackActions onClick={handleOnCompleteReplay}>
            <ActionImage src={replay_icon} />
            <ActionTitle>Replay</ActionTitle>
          </CompletionFeedbackActions>
          <CompletionFeedbackActions onClick={handleFavoriteClick}>
            <ActionImage
              src={
                isCourseFavorite
                  ? filled_bookmark_icon
                  : bookmark_icon
              }
            />
            <ActionTitle>
              {isCourseFavorite ? 'Added to Favorites' : 'Add to Favorites'}
            </ActionTitle>
          </CompletionFeedbackActions>
        </ActionsContainer>

        <ActionSubmitButton disabled={value === 0} onClick={() => onSessionCompleteSumbit(value)}>
          Submit
        </ActionSubmitButton>
      </CompletionFeedbackBox>
    </CompletionFeedbackContainer>
  )
}
